import { useQuery } from "react-query";
import { QueryKeys } from "@/network/queryKeys";
import { useSelector } from "react-redux";
import { Selectors as UserSelectors } from "@/store/user/selectors";
import { PremiumAPI } from "@/api/premium";

export const usePriceQuery = ({ promocode }) => {
  const userCurrency = useSelector(UserSelectors.getCurrency);
  const priceQuery = useQuery(
    [
      QueryKeys.premiumPrice,
      {
        promocode,
        userCurrency,
      },
    ],
    () =>
      PremiumAPI.getPrice({
        ...(promocode ? { promocode } : {}),
        currency: userCurrency,
      }),
    {
      keepPreviousData: true,
      staleTime: 0,
      cacheTime: Infinity,
    }
  );
  return priceQuery;
};
